var version = require('./lib/version');
var config = require('./config');
var utilities = require('./lib/modules/utilities');
var locations = require('./lib/modules/locations');
var notifications = require('./lib/modules/notifications');
var lanes = require('./lib/modules/lanes');
var gql = require('./lib/modules/gql');
var dms = require('./lib/modules/dms');
var customers = require('./lib/modules/customers');
var regions = require('./lib/modules/regions');
var repairorders = require('./lib/modules/repairorders');
var ridehail = require('./lib/modules/ridehail');
var tookan = require('./lib/modules/tookan');
var accessorials = require('./lib/modules/accessorials');
var { fragments, types } = require('./lib/modules/fragments');
var google = require('./lib/modules/google');
var authorizations = require('./lib/modules/authorizations');
var stripe = require('./lib/modules/stripe');
var moves = require('./lib/modules/moves');
var rating = require('./lib/modules/rating');
var utilities = require('./lib/modules/utilities');
var errors = require('./lib/modules/errors');
var dwolla = require('./lib/modules/dwolla');
var wallet = require('./lib/modules/wallet');
var events = require('./lib/modules/events');
var apollo = require('./lib/modules/apollo');
var invoices = require('./lib/modules/invoices');
var outcomes = require('./lib/modules/outcomes');
var configs = require('./lib/modules/configs');
var users = require('./lib/modules/users');
var batchjobs = require('./lib/modules/batchjobs');
var businesshours = require('./lib/modules/businesshours');

// Parent module to export
var sat = {
  version: version,
  config: config,
  configure: c => Object.assign(config, c), // Allows for partial overrides to the config object
  utilities: utilities,
  locations: locations,
  notifications: notifications,
  lanes: lanes,
  gql: gql,
  fragments: fragments,
  types: types,
  dms: dms,
  customers: customers,
  regions: regions,
  repairorders: repairorders,
  ridehail: ridehail,
  tookan: tookan,
  accessorials: accessorials,
  google: google,
  authorizations: authorizations,
  stripe: stripe,
  moves: moves,
  rating: rating,
  errors: errors,
  dwolla: dwolla,
  wallet: wallet,
  events: events,
  apollo: apollo,
  invoices: invoices,
  outcomes: outcomes,
  configs: configs,
  users: users,
  batchjobs: batchjobs,
  businesshours: businesshours,
};

// Initialize child modules with references to parent
gql.init(sat);
locations.init(sat);
notifications.init(sat);
lanes.init(sat);
rating.init(sat);
dms.init(sat);
customers.init(sat);
regions.init(sat);
repairorders.init(sat);
ridehail.init(sat);
tookan.init(sat);
accessorials.init(sat);
google.init(sat);
authorizations.init(sat);
stripe.init(sat);
moves.init(sat);
utilities.init(sat);
errors.init(sat);
dwolla.init(sat);
wallet.init(sat);
events.init(sat);
apollo.init(sat);
invoices.init(sat);
outcomes.init(sat);
configs.init(sat);
users.init(sat);
batchjobs.init(sat);
businesshours.init(sat);
module.exports = sat;
